import React, { PureComponent } from 'react'

import { connect } from 'react-redux'
import type { RootState } from 'reducers'

import { clearExport } from 'actions/app-actions'

export default (DecoratedComponent: React.ComponentType<any>) => {
  class ConnectedComponent extends PureComponent<any> {
    static displayName = 'Exporter'

    componentDidUpdate() {
      this.export(this.props.exportData)
    }

    post({ url, data, target }: any) {
      const fragment = document.createDocumentFragment()
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = url

      if (target) {
        form.target = target
      }

      form.setAttribute('style', 'display:none;')
      fragment.appendChild(form)

      Object.keys(data).forEach(key => {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.value = JSON.stringify(data[key])
        input.name = key
        form.appendChild(input)
      })
      document.body.appendChild(fragment)
      form.submit()
      document.body.removeChild(form)
    }

    get({ url, fileName }: any) {
      const node = document.createElement('a')
      node.href = url
      if (fileName) node.download = fileName
      document.body.appendChild(node)
      node.click()
      document.body.removeChild(node)
    }

    export(exportData: any) {
      const { clearExport } = this.props

      if (!exportData.url) return

      if (exportData?.method?.toLowerCase() === 'post') {
        this.post(exportData)
      } else {
        this.get(exportData)
      }

      clearExport()
    }

    render() {
      const { clearExport, exportData, ...rest } = this.props

      return <DecoratedComponent {...rest} />
    }
  }

  return connect(
    (s: RootState) => ({
      exportData: s.app.exportData,
    }),
    { clearExport },
  )(ConnectedComponent)
}
